import React from 'react'
import { Box, Toolbar, Typography } from "@mui/material";
import Footer from '../Component/Footer';
import Header from "../Component/header";
import { useLanguage } from '../context/LanguageContext';
import About from '../Component/About';
import DesktopFooter from "../Component/Desktopfooter";

const Aboutpage = () => {
    const { t } = useLanguage();
    return (
        <>
            <div className='text-Wrapper'>
               <Header/> 
                <Box>
                    <Toolbar>
                        <About />
                    </Toolbar>
                </Box>
            </div>
             <DesktopFooter/>
            <Footer />
        </>
    )
}

export default Aboutpage